import Swiper from 'swiper';
import { Navigation, Autoplay, EffectFade, Keyboard } from 'swiper/modules';

export default (id: string): void => {
  const homeSwiper = new Swiper(`${id}.swiper`, {
    modules: [Navigation, Autoplay, EffectFade, Keyboard],
    fadeEffect: {
      crossFade: true
    },
    slidesPerView: 1,
    navigation: {
      nextEl: `${id} .swiper-button-next`,
      prevEl: `${id} .swiper-button-prev`
    },
    effect: 'fade',
    speed: 800,
    loop: true,
    autoplay: {
      delay: 7000,
      disableOnInteraction: false
    },
    keyboard: true,
    on: {
      slideChange: (swiper) => {
        if (swiper && !swiper.autoplay.running) {
          swiper.autoplay.start();
        }
      }
    }
  });

  if (homeSwiper) {
    homeSwiper.autoplay.start();
  }

  const slides = document.querySelectorAll(`${id} .swiper-slide`);

  Array.prototype.forEach.call(slides, (slide: HTMLElement) => {
    const houseId = parseInt(slide.dataset.houseId ?? '0', 10);
    const buttons = slide.querySelectorAll('button');
    const openClassName = 'is-opened';

    const onClick = () => {
      const homeDropDown = document.querySelector<HTMLElement>(`#home-dropdown-${houseId}`);

      if (!homeDropDown) {
        return;
      }

      if (homeDropDown.classList.contains(openClassName)) {
        homeSwiper.autoplay.start();
      } else {
        homeSwiper.autoplay.stop();
      }

      homeDropDown.classList.toggle(openClassName);
    };

    Array.prototype.forEach.call(buttons, (button: HTMLElement) => {
      button.addEventListener('click', onClick);
    });
  });
};
